import styled from 'styled-components';
import { TRANSITION_SETTINGS, ICON_CONTAINER_WIDTH } from '../config.js';
import { IconButton } from '../../buttons/IconButton/index.js';
import { Typography } from '../../../foundation/Typography/styled.js';

var FadeOutContainer = styled.div.withConfig({
  displayName: "FadeOutContainer",
  componentId: "sc-36kj95-0"
})(["display:", ";justify-content:start;align-items:center;width:100%;opacity:1;overflow:hidden;white-space:nowrap;transition:all ", ";", ";"], function (_ref) {
  var $logotype = _ref.$logotype;
  return $logotype ? 'grid' : 'flex';
}, TRANSITION_SETTINGS, function (_ref2) {
  var $minimized = _ref2.$minimized;
  return $minimized && "\n    width: 0;\n    opacity: 0;\n  ";
});
var FadeOutSpacer = styled.div.withConfig({
  displayName: "FadeOutSpacer",
  componentId: "sc-36kj95-1"
})(["max-width:100%;display:flex;align-items:center;justify-content:space-between;flex:1 1 auto;"]);
var StyledIconButton = styled(IconButton).withConfig({
  displayName: "StyledIconButton",
  componentId: "sc-36kj95-2"
})(["width:", ";height:", ";flex-shrink:0;"], ICON_CONTAINER_WIDTH, ICON_CONTAINER_WIDTH);
var IconContainer = styled.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-36kj95-3"
})(["width:", ";height:", ";position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;"], ICON_CONTAINER_WIDTH, ICON_CONTAINER_WIDTH);
var StyledOverflowTypography = styled(Typography).withConfig({
  displayName: "StyledOverflowTypography",
  componentId: "sc-36kj95-4"
})(["overflow:hidden;text-overflow:ellipsis;max-width:100%;"]);

export { FadeOutContainer, FadeOutSpacer, IconContainer, StyledIconButton, StyledOverflowTypography };
